import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';
import { LayoutComponent } from './layouts/layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () =>
      import('./pages/authentication/authentication.route').then(
        (mod) => mod.AUTHENTICATION_ROUTES
      ),
  },
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/dashboard/dashboard.route').then(
        (mod) => mod.DASHBOARD_ROUTES
      ),
  },
];
